import {React} from "react";

export default function Header(){
    return(
        <>
            <div className="md:mx-auto relative imgTitleHeader flex justify-center">
                <div className="absolute top-1/2 -mt-[150px] lg:mx-0 mx-5">
                    <h1 className="lg:text-7xl text-5xl font-semibold text-white text-start strokeTitle">!Vive, conoce y disfruta¡</h1>
                    <p className="text-2xl text-white font-semibold strokeTitle">descubre tus lugares favoritos <br/>en un mismo lugar</p>
                </div>
            </div>
            <div className="flex -translate-y-[130px] lg:-translate-y-[160px] absolute top-2/2 left-0 right-0">
                <div className="mx-auto">
                    <div className="bg-white shadow-lg p-5 lg:p-10 rounded-lg">
                        <div className="grid grid-cols-3 lg:grid-cols-6 gap-10">
                            <div className='flex flex-col text-center'>
                                <div className="px-0 lg:px-5"><img src='/images/icon-airplane.png' alt='Viaje Redondo Viajes Manguen' className='w-full h-20' /></div>
                                <p className="text-fuchsia-500 font-bold text-base lg:text-lg">Viaje</p>
                            </div>
                            <div className='flex flex-col text-center'>
                                <div className="px-0 lg:px-5"><img src='/images/icon-suitcase.png' alt='Maleta Documentada Viajes Manguen' className='w-full h-20' /></div>
                                <p className="text-fuchsia-500 font-bold text-base lg:text-lg">Maletero</p>
                            </div>
                            <div className='flex flex-col text-center'>
                                <div className="px-0 lg:px-5"><img src='/images/icon-taxi.png' alt='Traslados Viajes Manguen' className='w-full h-20' /></div>
                                <p className="text-fuchsia-500 font-bold text-base lg:text-lg">Traslados</p>
                            </div>
                            <div className='flex flex-col text-center'>
                                <div className="px-0 lg:px-5"><img src='/images/icon-food.png' alt='Alimentos y bebidas Viajes Manguen' className='w-full h-20' /></div>
                                <p className="text-fuchsia-500 font-bold text-base lg:text-lg">Comidas</p>
                            </div>
                            <div className='flex flex-col text-center'>
                                <div className="px-0 lg:px-5"><img src='/images/icon-bed.png' alt='Alojamiento Viajes Manguen' className='w-full h-20' /></div>
                                <p className="text-fuchsia-500 font-bold text-base lg:text-lg">Alojamiento</p>
                            </div>
                            <div className='flex flex-col text-center'>
                                <div className="px-0 lg:px-5"><img src='/images/icon-cash.png' alt='Impuestos Viajes Manguen' className='w-full h-20' /></div>
                                <p className="text-fuchsia-500 font-bold text-base lg:text-lg">Impuestos</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}